'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

var _styles2 = require('../../WMTable/styles');

var _styles3 = _interopRequireDefault(_styles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	row: {
		display: 'table-row',
		width: '100%',
		height: '48px',

		striped: function striped(_striped) {
			return _striped ? { backgroundColor: _styles.colors.baseColors.offWhite } : {};
		},

		selected: function selected(_selected) {
			return _selected ? { backgroundColor: _styles.colors.baseColors.offWhite } : {};
		}
	},

	checkbox: Object.assign({}, _styles3.default.cell, { paddingLeft: '24px' })
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableRow/styles/index.js